import Vue from 'vue'
import Router from 'vue-router'
import About from './views/About.vue'
import Methodology from './views/Methodology.vue'
import Data from './views/Data.vue'
import Downloads from './views/Downloads.vue'
import Team from './views/Team.vue'
import Links from './views/Links.vue'
import Calculator from './views/Calculator.vue'
import Login from './views/Login.vue'
import store from './main'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  // scrollBehavior() {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve({ x: 0, y: 0 })
  //     }, 300)
  //   });
  // },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/methodology',
      name: 'methodology',
      component: Methodology
    },
    {
      path: '/data',
      name: 'data',
      component: Data
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: Downloads
    },
    {
      path: '/team',
      name: 'team',
      component: Team
    },
    {
      path: '/links',
      name: 'links',
      component: Links
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: Calculator
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('Authenticated: ' + store.state.authenticated);
  console.log('FROM: ' + from.name);
  console.log('TO: ' + to.name);
  console.log('NEXT: ' + next);

    if(to.name != 'login') {
        if(store.state.authenticated) {
            next()
        } else {
            store.state.returnUrl = to.name
            router.push('login')
        }
    } else {
        next()
    }
})

export default router
